// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contextual-area .config-payments .forced-flex{-ms-flex-preferred-size:100%!important;flex-basis:100%!important;max-width:100%!important}.contextual-area .config-payments .forced-flex:first-child{border-bottom:1px solid rgba(0,0,0,.12);margin-bottom:10px;padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
